<!--
	@name common-structure-directory
	@description Video Player
	@date 2020/04/11
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<common-dialog ref="dialog" :component="$options.name">
		<template #body>
			<div class="video-container">
				<iframe
					:id="`vimeo-player-${id}`"
					class="video-iframe"
					allowfullscreen=""
					allow="clipboard-write"
					title="Vimeo Video Player"
					:src="source"
					data-ready="true"
				/>
			</div>
		</template>
	</common-dialog>
</template>

<script>
	import { EventBus } from '@/utils';
	import CommonDialog from '@/component/common/dialog';

	export default {
		name: 'app-dialog-vimeo-player',

		components: { CommonDialog },

		data() {
			return {
				source: null
			};
		},

		created() {
			EventBus.$on('common-dialog-closed', this.close);
		},

		destroyed() {
			EventBus.$off('common-dialog-closed', this.close);
		},

		methods: {
			/**
			 * @name open
			 * @description set source of the video and open dialog
			 */
			open(source) {
				this.source = source;
				this.$refs.dialog.open();
			},

			close() {
				this.source = null;
			}
		}
	};
</script>

<style scoped>
	.video-iframe {
		width: 100%;
		height: 100%;
		border: none;
	}

	.video-container {
		width: 100%;
		height: 100%;
		aspect-ratio: 1.77777;
	}
</style>
